<template>
  <div>
    <ProjectOverview />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import ProjectOverview from "@/components/projects/project/container/ProjectOverview.vue";
export default Vue.extend({
  components: {
    ProjectOverview,
  },
});
</script>
